<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
      <div class="row">
        <div class="col-md-8">
          <lib-page-header page-title="Relatório Personalizado"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/global/exam.png">
          </lib-page-header>
        </div>
        <div class="col-md-4">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/relatorios-personalizados']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-4 pr-0">
          <i class="fa fa-print" style="position: absolute; top: 10px; left: 25px;"></i>
          <input #titulo_ placeholder="Informe o nome do relatório" formControlName="nome" type="text"
            class="form-control form-control-sm" style="padding-left: 30px">
        </div>
        <div class="col-md-8">
          <input placeholder="Informe a descrição do relatório" formControlName="descricao" type="text"
            class="form-control form-control-sm">
        </div>
      </div>
      <hr class="mt-2 mb-2" />
      <div class="accordion" id="accordion">
        <div class="card" style="font-size: 0.9rem;">
          <div class="card-header justify-content-between" style="padding: 10px 5px" id="bloco-filtros">
            <button class="btn" data-toggle="collapse" data-target="#collapseFiltros" aria-expanded="true"
              aria-controls="collapseFiltros"><i class="fa fa-sliders" style="padding-right: 10px"></i>Campos e
              Filtros</button>
            <button (click)="buscarDados(true)" class="btn btn-success float-right mr-4"
              style="font-size: 13px; margin-left: 10px;">
              <i class="fa fa-play"></i>
              Executar Relatório
            </button>
          </div>
          <div class="collapse show" id="collapseFiltros" aria-labelledby="bloco-filtros" data-parent="#accordion">
            <div class="card-body p-2">
              <div class="row">
                <div class="col-md-5 pl-1 pr-1">
                  <div class="card" style="min-height: 380px">
                    <div class="card-header" style="background: #17a2b8; color: #fff;">
                      <i class="fa fa-list"></i>
                      &nbsp;Campos
                    </div>
                    <div class="card-body p-0" *ngIf="listGrupos?.length > 0">
                      <div class="row m-0">
                        <div class="col-6 p-0">
                          <select [(ngModel)]="moduloAtual" (change)="carregarModulos(true)"
                            [ngModelOptions]="{standalone: true}" class="custom-select custom-select-sm">
                            <option [ngValue]="item" *ngFor="let item of listModulos">
                              {{item.modulo}}
                            </option>
                          </select>
                        </div>
                        <div class="col-6 p-0">
                          <select [(ngModel)]="grupoAtual" (change)="filtrarDisponiveis()"
                            [ngModelOptions]="{standalone: true}" class="custom-select custom-select-sm">
                            <option [ngValue]="item.nome" *ngFor="let item of listGrupos">
                              {{item.nome}}
                            </option>
                          </select>
                        </div>
                      </div>
                      <p-pickList [source]="camposDisponiveis" [target]="camposSelecionados" [responsive]="true"
                        [showSourceControls]="false" [showTargetControls]="false" [sourceStyle]="{'height':'300px'}"
                        [targetStyle]="{'height':'300px'}" dragdrop="true">
                        <ng-template let-item pTemplate="item">
                          <span>{{item.titulo}}</span>&nbsp;<small class="text-secondary">({{item.subTitulo}})</small>
                        </ng-template>
                      </p-pickList>
                    </div>
                  </div>
                </div>
                <div class="col-md-5 pl-0 pr-1">
                  <div class="card" style="min-height: 380px">
                    <div class="card-header justify-content-between" style="background: #17a2b8; color: #fff;">
                      <span>
                        <i class="fa fa-filter"></i>
                        &nbsp;Filtros&nbsp;
                      </span>
                      <button class="btn btn-outline-light btn-sm float-right" (click)="adicionarFiltro()"
                        style="margin: -4px 0px">
                        <i class="fa fa-plus"></i> Adicionar Filtro
                      </button>
                    </div>
                    <div class="card-body p-0">
                      <ul class="list-group" *ngIf="filtros?.length > 0">
                        <li class="list-group-item d-flex justify-content-between align-items-center"
                          style="padding: 2px 5px" *ngFor="let filtro of filtros; let idx = index">
                          <div class="col-md-5 p-0">
                            <p-autoComplete [(ngModel)]="filtro.campo" [field]="campoConversor" [forceSelection]="true"
                              [ngModelOptions]="{standalone: true}" [suggestions]="listCampos"
                              (completeMethod)="filtrarCampos($event)" placeholder="Informe o campo"
                              inputStyleClass="form-control form-control-sm ui-inputborder" minLength="2"
                              [style]="{ width: '100%' }" [autoHighlight]="true">
                              <ng-template let-campo pTemplate="item">
                                {{campo.titulo}} <small class="text-secondary">({{campo.subTitulo}})</small>
                              </ng-template>
                            </p-autoComplete>
                          </div>
                          <div class="col-md-3 p-0" *ngIf="listaOperadores?.length > 0">
                            <select [(ngModel)]="filtro.operador" [ngModelOptions]="{standalone: true}"
                              style="border: none !important" class="custom-select custom-select-sm">
                              <option [ngValue]="item.id" *ngFor="let item of listaOperadores">
                                {{item.nome}}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-3 p-0">
                            <input
                              *ngIf="filtro.operador !== 'null' && filtro.operador !== 'not_null' && filtro.campo && filtro.campo?.tipo === 'String'"
                              [(ngModel)]="filtro.valor" [ngModelOptions]="{standalone: true}" type="text"
                              class="form-control form-control-sm" id="filtro_valor{{idx}}">
                            <input
                              *ngIf="filtro.operador !== 'null' && filtro.operador !== 'not_null' && filtro.campo && filtro.campo?.tipo === 'Number'"
                              [(ngModel)]="filtro.valor" [ngModelOptions]="{standalone: true}" type="text"
                              class="form-control form-control-sm text-right" id="filtro_valor{{idx}}" unmask="true"
                              [imask]="imaskConfig">
                            <input
                              *ngIf="filtro.operador !== 'null' && filtro.operador !== 'not_null' && filtro.campo && filtro.campo?.tipo === 'Date'"
                              [(ngModel)]="filtro.valor" [ngModelOptions]="{standalone: true}" type="text"
                              class="form-control form-control-sm" id="filtro_valor{{idx}}" [unmask]="false"
                              [imask]="{mask: '00/00/0000'}">
                            <div
                              *ngIf="filtro.operador !== 'null' && filtro.operador !== 'not_null' && filtro.campo && filtro.campo?.tipo === 'Boolean'"
                              class="checkbox checbox-switch switch-primary">
                              <label>
                                <input [(ngModel)]="filtro.valor" [ngModelOptions]="{standalone: true}" type="checkbox"
                                  class="form-control form-control-sm" id="filtro_valor{{idx}}" />
                                <span></span>
                              </label>
                            </div>
                          </div>
                          <div class="float-right p-0">
                            <button class="btn float-right" (click)="removerFiltro(idx)">
                              <i class="fa fa-close"></i>
                            </button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 pl-0 pr-1">
                  <div class="card">
                    <div class="card-header" style="background: #17a2b8; color: #fff;">
                      <i class="fa fa-sort-alpha-down"></i>
                      &nbsp;Ordenação
                    </div>
                    <div class="card-body p-0">
                      <p-autoComplete [(ngModel)]="selectOrdenacao" [field]="campoConversor" [forceSelection]="true"
                        [ngModelOptions]="{standalone: true}" [suggestions]="listCampos"
                        (completeMethod)="filtrarCampos($event)" placeholder="Adicione a ordenação"
                        inputStyleClass="form-control form-control-sm" minLength="2" [style]="{ width: '100%' }"
                        [autoHighlight]="true" (onSelect)="adicionarOrdenacao()">
                        <ng-template let-campo pTemplate="item">
                          {{campo.titulo}} <small class="text-secondary">({{campo.subTitulo}})</small>
                        </ng-template>
                      </p-autoComplete>
                      <ul class="list-group" *ngIf="ordenacao?.length > 0">
                        <li class="list-group-item d-flex justify-content-between align-items-center"
                          style="padding: 0 5px" *ngFor="let ordem of ordenacao; let idx = index">
                          <button class="btn btn-outline-info btn-sm" (click)="toggleOrdenacao(ordem)"
                            style="padding: 0 7px; margin-right: 5px;"
                            title="{{ordem?.asc ? 'crescente' : 'decrescente'}}">
                            <i class="fa fa-sort-{{ordem?.asc ? 'down' : 'up'}}"></i>
                          </button>
                          <label class="m-0">{{ordem.campo?.titulo}} <small
                              class="text-secondary">({{ordem.campo?.subTitulo}})</small></label>
                          <button class="btn" (click)="removerOrdenacao(idx)" style="padding: 3px">
                            <i class="fa fa-close"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" style="background: #17a2b8; color: #fff;">
                      <i class="fa fa-sitemap"></i>
                      &nbsp;Agrupamento
                    </div>
                    <div class="card-body p-0">
                      <p-autoComplete [(ngModel)]="selectAgrupamento" [field]="campoConversor" [forceSelection]="true"
                        [ngModelOptions]="{standalone: true}" [suggestions]="listCampos"
                        (completeMethod)="filtrarCampos($event)" placeholder="Adicione o agrupamento"
                        inputStyleClass="form-control form-control-sm ui-inputborder" minLength="2"
                        [style]="{ width: '100%' }" [autoHighlight]="true" (onSelect)="adicionarAgrupamento()">
                        <ng-template let-campo pTemplate="item">
                          {{campo.titulo}} <small class="text-secondary">({{campo.subTitulo}})</small>
                        </ng-template>
                      </p-autoComplete>
                      <ul class="list-group" *ngIf="agrupamento?.length > 0">
                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 0"
                          *ngFor="let group of agrupamento; let idx = index">
                          <span></span>
                          <label class="m-0">{{group.titulo}} <small
                              class="text-secondary">({{group.subTitulo}})</small></label>
                          <button class="btn" (click)="removerAgrupamento(idx)" style="padding: 3px">
                            <i class="fa fa-close"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header" style="background: #17a2b8; color: #fff;">
                      <i class="fa fa-euro-sign"></i>
                      &nbsp;Totalizador
                    </div>
                    <div class="card-body p-0">
                      <p-autoComplete [(ngModel)]="selectTotalizador" [field]="campoConversor" [forceSelection]="true"
                        [ngModelOptions]="{standalone: true}" [suggestions]="listCampos"
                        (completeMethod)="filtrarCampos($event)" placeholder="Adicione o totalizador"
                        inputStyleClass="form-control form-control-sm ui-inputborder" minLength="2"
                        [style]="{ width: '100%' }" [autoHighlight]="true" (onSelect)="adicionarTotalizador()">
                        <ng-template let-campo pTemplate="item">
                          {{campo.titulo}} <small class="text-secondary">({{campo.subTitulo}})</small>
                        </ng-template>
                      </p-autoComplete>
                      <ul class="list-group" *ngIf="totalizador?.length > 0">
                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 0"
                          *ngFor="let tot of totalizador; let idx = index">
                          <span></span>
                          <label class="m-0">{{tot.titulo}} <small
                              class="text-secondary">({{tot.subTitulo}})</small></label>
                          <button class="btn" (click)="removerTotalizador(idx)" style="padding: 3px">
                            <i class="fa fa-close"></i>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header justify-content-between" style="padding: 10px 5px" id="bloco-dados">
            <button id="btn-dados" class="btn" data-toggle="collapse" data-target="#collapseDados" aria-expanded="false"
              aria-controls="collapseDados">
              <i class="fa fa-list-alt" style="padding-right: 10px"></i>Dados
            </button>
            <lib-export-list *ngIf="listDados" (acao)="exportarListagem($event)"></lib-export-list>
          </div>
          <div class="collapse" id="collapseDados" aria-labelledby="bloco-dados" data-parent="#accordion">
            <div class="card-body p-2">
              <div class="row">
                <div class="col-md">
                  <table class="table table-hover table-personalizado table-eddy" cellspacing="0">
                    <thead>
                      <tr *ngIf="camposSelecionados?.length > 0">
                        <th [hidden]="col.agrupar" class="text-center" *ngFor="let col of camposSelecionados">
                          {{col.titulo}} <small class="text-secondary"
                            style="display: block">({{col.subTitulo}})</small>
                        </th>
                      </tr>
                    </thead>
                    <tbody [innerHTML]="retornaConteudoTabela() | safeHtml">
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row" *ngIf="false">
                <div class="offset-6 col-6" style="text-align: right"
                  *ngIf="listDadosFormatado && listDadosFormatado.length > 0">
                  <span class="mr-1">{{paginaCorrente}} de</span>
                  <span class="ml-1">{{paginaTotal}} </span>
                  <a style="cursor: pointer" (click)="paginaAnterior()" aria-label="Previous" class="mr-3 ml-2">
                    <img src="assets/img/comum/left-24.png" alt="anterior" height="20" width="20">
                  </a>
                  <a style="cursor: pointer" (click)="proximaPagina()" aria-label="Next" class="ml-1">
                    <img src="assets/img/comum/right-24.png" alt="próximo" height="20" width="20">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="modalOpcoesPdf" tabindex="-1" role="dialog" aria-labelledby="opcoesPdfModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="opcoesPdfModalLabel">Opções do relatório em PDF</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Selecione o tipo de orientação do relatório</h6>
              <div class="checkbox checbox-switch switch-info">
                <label>
                  <input [(ngModel)]="orientacao" [ngModelOptions]="{standalone: true}" type="checkbox" />
                  <span></span>
                  Imprimir em Paisagem
                </label>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
              <button type="button" class="btn btn-primary btn-sm" (click)="exportarListagem('pdf')">Imprimir</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="modalFiltros" tabindex="-1" role="dialog" aria-labelledby="filtrosModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="filtrosModalLabel">Relatório</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Preencha os filtros do relatório para executá-lo</h6>
              <ul class="list-group" *ngIf="filtrosDinamicos?.length > 0">
                <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px 5px"
                  *ngFor="let filtro of filtrosDinamicos; let idx = index">
                  <div class="float-left">
                    <span class="font-weight-bold">{{ filtro.campo?.titulo }}</span>
                    <small class="text-secondary">({{ filtro.campo?.subTitulo }}):</small>
                    <span style="margin-left: 2px; display: block;">
                      {{ funcaoService.obterNomePorChave(listaOperadores, filtro.operador) }}
                    </span>
                  </div>
                  <div class="float-right">
                    <input *ngIf="filtro.campo && filtro.campo?.tipo === 'String'" [(ngModel)]="filtro.valorTemp"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control form-control-sm"
                      id="filtro_valor{{idx}}">
                    <input *ngIf="filtro.campo && filtro.campo?.tipo === 'Number'" [(ngModel)]="filtro.valorTemp"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control form-control-sm text-right"
                      id="filtro_valor{{idx}}" unmask="true" [imask]="imaskConfig">
                    <input *ngIf="filtro.campo && filtro.campo?.tipo === 'Date'" [(ngModel)]="filtro.valorTemp"
                      [ngModelOptions]="{standalone: true}" type="text" class="form-control form-control-sm"
                      id="filtro_valor{{idx}}" [unmask]="false" [imask]="{mask: '00/00/0000'}">
                    <div *ngIf="filtro.campo && filtro.campo?.tipo === 'Boolean'"
                      class="checkbox checbox-switch switch-primary">
                      <label>
                        <input [(ngModel)]="filtro.valorTemp" [ngModelOptions]="{standalone: true}" type="checkbox"
                          class="form-control form-control-sm" id="filtro_valor{{idx}}" />
                        <span></span>
                      </label>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-success btn-sm" (click)="buscarDados(true)">
                <i class="fa fa-play"></i> Executar Relatório
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">url {{ entidadeForm.get('url')?.value | json}}</pre> -->
  </div>
</div>